import { ECustomAction } from '../../types/customActions';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatCustomActionModalActionTypes {
  Show = 'chatCustomActionModal/show',
  Hide = 'chatCustomActionModal/hide',
}

export type TChatCustomActionModalShowPayload = {
  text: string;
  cancelButtonText: string;
  confirmButtonText: string;
  action: ECustomAction;
  chatId: string;
};

export type TChatCustomActionModalAction =
  | ITypedReduxAction<EChatCustomActionModalActionTypes.Show, TChatCustomActionModalShowPayload>
  | ITypedReduxAction<EChatCustomActionModalActionTypes.Hide, void>;
